import React from "react";
import { object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { getTemplateName } from "../../utils";

import { FOLLOW_US_ICONS } from "../../../constants";
import { SvgIconHandler } from "../../atoms/SvgIconHandler";

export const FollowUsIcons = ({ socialLinks }) => {
  if (!Object.keys(socialLinks).length) return;

  // Get pageType from Redux store for template name
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], null);

  // Track social media icon clicks for dataLayer analytics
  const trackSocialClick = (e, icon, url) => {
    e.preventDefault();
    e.stopPropagation();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_footer_clicks",
      link_url: url,
      link_text: icon.label.toLowerCase(),
      link_category: "social-media",
      category: "footer",
      sub_category: icon.label.toLowerCase(),
      content_id: "NA",
      template_name: getTemplateName(pageType) || "footer-social",
      platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      eventCallback: function () {
        window.open(url, "_blank");
      },
    });
  };

  return FOLLOW_US_ICONS.map((icon) => {
    const { type, label, urlKey } = icon;
    const socialUrl = socialLinks[urlKey];
    return (
      <li className="follow-us-item" key={type}>
        <div onClick={(e) => trackSocialClick(e, icon, socialUrl)} style={{ display: "contents" }}>
          <a href={socialUrl} target="_blank" rel="nofollow noopener noreferrer" aria-label={label}>
            <SvgIconHandler type={type} width="28" height="28" />
          </a>
        </div>
      </li>
    );
  });
};

FollowUsIcons.propTypes = {
  socialLinks: object,
};
